import {
  Box,
  Flex,
  Text,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import SchoolsTab from './SchoolsTab';
import CoursesTab from './CoursesTab';
import ClassesTab from './ClassesTab';
import analytics from '../../../../segmentTracking';

const AcademicManagement = () => {
  const [currentUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Add tracking for tab changes and refresh active tab
  const handleTabChange = (index) => {
    const tabNames = ['Schools', 'Courses', 'Classes'];
    const tabName = tabNames[index];

    setActiveTabIndex(index);
    // Trigger refresh only for the newly active tab
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <Box width={'65%'} margin={'24px auto 48px'}>
      <Box>
        <Text fontSize={'20px'} fontWeight={'700'}>
          Academic Management
        </Text>
        <Flex flexDir={'column'} margin={'10px 0'}>
          <Flex justifyContent={'space-between'} alignItems={'flex-start'}>
            <Box flexBasis={'70%'}>
              <Text
                fontSize={'14px'}
                lineHeight={'20px'}
                fontWeight={'400'}
                color={'#757575'}
                pt={'4px'}
              >
                Manage schools, courses, and classes for your institution
              </Text>
            </Box>
          </Flex>
        </Flex>
      </Box>

      <Flex flexDir={'column'} margin={'10px 0'}>
        <Box mt={6}>
          <Tabs
            variant="enclosed"
            index={activeTabIndex}
            onChange={handleTabChange}
          >
            <TabList>
              <Tab>Schools</Tab>
              <Tab>Courses</Tab>
              <Tab>Classes</Tab>
            </TabList>

            <TabPanels>
              {/* Schools Tab */}
              <TabPanel>
                <SchoolsTab
                  refreshTrigger={activeTabIndex === 0 ? refreshTrigger : 0}
                />
              </TabPanel>

              {/* Courses Tab */}
              <TabPanel>
                <CoursesTab
                  refreshTrigger={activeTabIndex === 1 ? refreshTrigger : 0}
                />
              </TabPanel>

              {/* Classes Tab */}
              <TabPanel>
                <ClassesTab
                  refreshTrigger={activeTabIndex === 2 ? refreshTrigger : 0}
                />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Flex>
    </Box>
  );
};

export default AcademicManagement;
